import React, {FC} from "react"

import {H1, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {CurrencyType} from "@irati/payments/enums"

import {RedStrikethrough} from "./styled"
interface Props extends InjectIntl {
  originalCost: number
  savingsCost: number
  currencyCode: CurrencyType
  invert: boolean
  inline?: boolean
}

const MonthlyPrice: FC<Props> = ({originalCost, savingsCost, currencyCode, invert, inline}) => {
  const theme = useTheme()
  const color = invert ? theme.colors.greys.white : theme.colors.greys.black
  return (
    <>
      <Flex direction="row" justifyContent={inline ? "flex-start" : "flex-end"} alignItems="center" marginTop={2}>
        {originalCost && originalCost !== savingsCost && (
          <RedStrikethrough>
            <Body large marginRight={1} color={color}>
              {formatCurrency({currencyCode, value: originalCost})}
            </Body>
          </RedStrikethrough>
        )}
        <H1 color={color}>{formatCurrency({currencyCode, value: savingsCost})}</H1>
        {inline && (
          <Body color={color} small marginLeft>
            <FormattedMessage id="admin.billing.renewals.renewalCard.perUserPerMonth" />
          </Body>
        )}
      </Flex>
      {!inline && (
        <Flex justifyContent="flex-end">
          <Body color={color}>
            <FormattedMessage id="admin.billing.renewals.renewalCard.perMonth" />
          </Body>
        </Flex>
      )}
    </>
  )
}

export default injectIntl(MonthlyPrice)
